<div class="firstDiv" style="margin-top: 10%">
  <div class="mainDiv">
    <h1 class="h2_font_size">Your Order has been placed Successfully!</h1>
  </div>
  <div class="mainDiv" style="text-align: center">
    <button class="btn btn-primary" (click)="download()" id="downloadBtnStyle">
      Order History</button>&nbsp;&nbsp;&nbsp;&nbsp;
    <!-- <button class="btn btn-warning" (click)="go()">GO</button> -->
  </div>
</div>